<template>
  <div>
    <p v-if="showDate"
       style="font-size: 13px; color: #A5B4C0;"
       class="font-bold leading-none"
    >{{formattedDate(meetingNoteList[0]?.startDate)}}</p>
    <p v-else style="font-size: 13px; color: #4A5A69;" class="font-bold leading-none">{{$t('extendMenu.meetingNote.listTitle')}}</p>
    <div class="mt-2 space-y-2">
      <RoomMeetingNoteItem v-for="meetingNoteItem in meetingNoteList"
                           :show-buttons="showDate"
                           :key="meetingNoteItem.key" 
                           :note="meetingNoteItem"
                           @click="(note) => $emit('click', note)"
      />
    </div>
  </div>
</template>

<script>

import RoomMeetingNoteItem from '@/components/Room/MeetingNote/Item.vue';
import moment from "moment";

export default {
  name: 'RoomMeetingNoteList',
  components: {
    RoomMeetingNoteItem,
  },
  props: {
    meetingNoteList: { type: Array, default: () => [] },
    showDate: {
      type: Boolean,
      default: true
    },
  },
  computed: {
    formattedDate() {
      return date => {
        if(this.$i18n.locale === 'en'){
          return date && new Date(date).toLocaleDateString("en", {weekday: 'long', day: '2-digit', month: 'long', year: 'numeric'});
        }
        return date && moment(date).format('YYYY-MM-DD ') + this.weekDayName(moment(date).format('d'));
      }
    },
    weekDayName() {
      return weekday => {
        switch(weekday) {
          case '0':
            return '일요일'
          case '1':
            return '월요일'
          case '2':
            return '화요일'
          case '3':
            return '수요일'
          case '4':
            return '목요일'
          case '5':
            return '금요일'
          case '6':
            return '토요일'
          default:
            return 'UNKOWN'
        }
      }
    },
  },
  methods: {
  }
}
</script>